import React from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter } from 'react-router-dom';
import PublicRouter from './PublicRouter';

const ApplicationRouter = ({ publicModules = [] }) => {

  return (
    <BrowserRouter>
        { <PublicRouter publicModules={publicModules} /> }
    </BrowserRouter>
  );
};

ApplicationRouter.propTypes = {
  publicModules: PropTypes.array,
};

export default ApplicationRouter;
